export default "__VITE_ASSET__WfjBMhfR__"